import {generateAsyncActionCreators} from '../core/reduxUtils';

const getGoogleAdUnitListingPageActionCreators = generateAsyncActionCreators(
  'GET_GOOGLE_AD_UNIT_LISTING_PAGE',
  (body) => ({
    body,
  })
);

const actionCreators = {
  getGoogleAdUnit: {
    ...getGoogleAdUnitListingPageActionCreators,
  },

  clearAdUnit() {
    return {
      type: 'CLEAR_GOOGLE_AD_UNIT_LISTING_PAGE',
    };
  },
};

export {
  actionCreators,
  getGoogleAdUnitListingPageActionCreators,
};
